import { getActionConstant, mergeRanges, mergeItems } from './util.js';
import Constants from '../Constants.js';

/*
  {
    items : [ ...query results ],
    ranges : [ [ 0, 1000 ], [ 1500, 2000 ], .... ], // disparate sets of paginated data with gaps
    status : <loading|success|error>,
    name : <queryName>,
    lastPagination : {
      perPage : <number>,
      startIndex : <number>
    }
  }
*/

function create({
  mode
}) {
  const initialState = {
    mode,
    queries: {},
    results: {}
  };
  function loading(state, action) {
    let nState = {
      ...state
    };
    const {
      queryName,
      queryable
    } = action;

    // if we have changed devices queried or something, we need to clear the results
    const nQueryable = typeof queryable === 'object' && queryable != null ? queryable.id : queryable;
    let prevQueryable = nState.results[queryName] && nState.results[queryName].queryable;
    prevQueryable = typeof prevQueryable === 'object' && prevQueryable != null ? prevQueryable.id : prevQueryable;
    if (nQueryable !== prevQueryable) {
      nState = clear(nState, action);
    }
    const nResults = {
      ...nState.results
    };
    nState.results = nResults;
    let nQuery = {
      status: Constants.QUERY_STATUS_LOADING,
      name: queryName,
      queryable
    };
    if (nResults[queryName]) {
      nQuery = {
        ...nResults[queryName],
        status: Constants.QUERY_STATUS_LOADING,
        queryable
      };
    }
    nResults[queryName] = nQuery;
    return nState;
  }
  function success(state, action) {
    const nState = {
      ...state
    };
    const nResults = {
      ...nState.results
    };
    const {
      queryName,
      results,
      lastQueried
    } = action;
    nState.results = nResults;
    let items, startIndex, perPage, lastPagination, range;
    if (results) {
      items = results.items;
      startIndex = results.startIndex;
      perPage = results.perPage;
      lastPagination = {
        startIndex,
        perPage
      };
      range = [startIndex, startIndex + perPage];
    }
    let nItems = [],
      nRanges = [],
      queryable;
    if (nResults[queryName]) {
      nItems = nResults[queryName].items || [];
      nRanges = nResults[queryName].ranges || [];
      queryable = nResults[queryName].queryable;
    }
    nRanges.push(range);
    nRanges = mergeRanges(nRanges);
    nItems = mergeItems(nItems, items, range);
    nResults[queryName] = {
      ranges: nRanges,
      items: nItems,
      page: lastPagination,
      status: Constants.QUERY_STATUS_SUCCESS,
      name: queryName,
      queryable,
      lastQueried
    };
    return nState;
  }
  function failure(state, action) {
    const nState = {
      ...state
    };
    const nResults = {
      ...nState.results
    };
    const {
      queryName,
      error
    } = action;
    nState.results = nResults;
    nResults[queryName] = {
      ...nResults[queryName],
      status: Constants.QUERY_STATUS_FAILED,
      error
    };
    return nState;
  }
  function clear(state, action) {
    const nState = {
      ...state
    };
    const nResults = {
      ...nState.results
    };
    const {
      queryName
    } = action;
    nState.results = nResults;
    nResults[queryName] = {
      status: Constants.QUERY_STATUS_SUCCESS,
      name: queryName,
      items: [],
      ranges: []
    };
    return nState;
  }
  function addUpdateQuery(state, action) {
    const nState = clear(state, {
      ...action,
      queryName: action.name
    });
    const nQueries = {
      ...nState.queries
    };
    const {
      name,
      query
    } = action;
    nQueries[name] = query;
    nState.queries = nQueries;
    return nState;
  }
  function removeQuery(state, action) {
    const nState = {
      ...state
    };
    const nQueries = {
      ...nState.queries
    };
    const {
      name
    } = action;
    delete nQueries[name];
    nState.queries = nQueries;
    return nState;
  }

  // eslint-disable-next-line default-param-last
  return function reducer(state = initialState, action) {
    switch (action.type) {
      case getActionConstant(Constants.START_QUERY, mode):
        return loading(state, action);
      case getActionConstant(Constants.QUERY_ERROR, mode):
        return failure(state, action);
      case getActionConstant(Constants.QUERY_SUCCESS, mode):
        return success(state, action);
      case getActionConstant(Constants.QUERY_CLEAR_RESULTS, mode):
        return clear(state, action);
      case getActionConstant(Constants.ADD_QUERY, mode):
        return addUpdateQuery(state, action);
      case getActionConstant(Constants.REMOVE_QUERY, mode):
        return removeQuery(state, action);
      case getActionConstant(Constants.UPDATE_QUERY, mode):
        return addUpdateQuery(state, action);
      default:
        return state;
    }
  };
}
export default {
  create
};